@if (fileUrl) {
  <div class="custom-image-main">
    @if (type === IMAGE && fileUrl) {
      <img class="image" [src]="fileUrl" [alt]="alt" [title]="title" />
    }
    @if (type === YOUTUBE && fileUrl) {
      <iframe class="youtube" [src]="fileUrl" frameborder="0" allowfullscreen></iframe>
    }
    @if (type === VIDEO) {
      <video
        class="video"
        (click)="videoClickHandler($event)"
        [autoplay]="videoAutoPlay"
        type="video/mp4"
        [attr.controls]="showVideoControls ? showVideoControls : null"
        controlsList="nodownload"
        >
        <source [src]="fileUrl" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    }
    @if (!fileUrl) {
      <div [dir]="direction" class="invalid-msg">Invalid file format</div>
    }
    @if (type === YOUTUBE || type === VIDEO || isVideo) {
      <span class="youtubedrag"></span>
    }
  </div>
}
